var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurvedWalls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 25.3333H28V28H25.3333V25.3333ZM25.3333 22.6667H28V20H25.3333V22.6667ZM4 17.3333H6.66667V14.6667H4V17.3333ZM4 22.6667H6.66667V20H4V22.6667ZM4 12H6.66667V9.33333H4V12ZM4 6.66667H6.66667V4H4V6.66667ZM9.33333 6.66667H12V4H9.33333V6.66667ZM20 28H22.6667V25.3333H20V28ZM14.6667 28H17.3333V25.3333H14.6667V28ZM20 28H22.6667V25.3333H20V28ZM9.33333 28H12V25.3333H9.33333V28ZM4 28H6.66667V25.3333H4V28ZM28 10.6667C28 6.98667 25.0133 4 21.3333 4H14.6667V6.66667H21.3333C23.5333 6.66667 25.3333 8.46667 25.3333 10.6667V17.3333H28V10.6667Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedWalls);
export default __webpack_public_path__ + "static/media/curved-walls.d85ceb875f254c40ef3b5a3b15d6b2bf.svg";
export { ForwardRef as ReactComponent };